import React from 'react';
import './btnStyle.scss';
import tickIcon from './img/tick.svg'; 
import activeTickIcon from './img/tick-active.svg';  

const SecondaryButton = ({ label, onClick, isActive, disabled, isTickIconShow = true }) => {
  return (
    <button
      className={`btn btn-secondary ${isActive ? 'active' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {isTickIconShow && <img
        src={isActive ? activeTickIcon : tickIcon}
        alt="tick icon"
        className="btn-icon"
      />}
      {label}
    </button>
  );
};

export default SecondaryButton;
